import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "adult-content"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Elmúltál 18 éves? ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " A megtekinteni kívánt szavazás csak nagykorú nézőink számára elérhető. Kérjük, hogy az alábbiakban nyilatkozz, hogy betöltötted-e a tizennyolcadik életéved. ", -1)
const _hoisted_4 = { class: "adult-content__footer" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Igen ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Nem ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_headline = _resolveComponent("headline")!
  const _component_cta_button = _resolveComponent("cta-button")!

  return (_ctx.isActive)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_headline, {
          size: "large",
          class: "adult-content__header"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _hoisted_3,
        _createElementVNode("footer", _hoisted_4, [
          _createVNode(_component_cta_button, {
            class: "adult-content__btn",
            theme: "primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.accept()))
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_cta_button, {
            class: "adult-content__btn",
            theme: "secondary",
            to: { name: 'vote-list' }
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ])
      ]))
    : _renderSlot(_ctx.$slots, "default", { key: 1 })
}